import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Product} from '../models/product.model';
import {AccountType, SubscriptionPlan, SubscriptionStatus} from '@ee/common/enums';
import {Price} from '../models/price.model';

@Component({
  selector: 'ee-product',
  template: `
    <div class="subscription-plan">
      <div class="product-header mb-6 relative"
           [ngClass]="{'disabled': !!product.disabled, 'current': product.plan === currentPlan &&
           subscriptionStatus === subscriptionStatuses.SUBSCRIPTION_ACTIVE}">
        <div class="flex flex-row space-between">
          <h2>{{ product.display_name }}</h2>
          @if (product.highlight) {
            <div class="mat-chips status p-0 popular">
              <span class="mat-chip past-due">Most Popular</span>
            </div>
          }
        </div>
        <div class="flex flex-row items-baseline">
          <h1>
            {{ product.prices[term]?.normalized_price | currency }}
          </h1>
          <div class="currency">{{ product.prices[term]?.currency?.toUpperCase() }}</div>
        </div>
        <div>per user/month</div>
      </div>
      @if (product.description) {
        <div class="description">{{ product.description }}</div>
      }
      <div class="action mb-4">
        @if (actionButtonOverride) {
          @if (product.plan === currentPlan && lockCurrentPlan) {
            <button type="button" class="no-link current-plan" [tp]="product.more_info">
              Current Plan
            </button>
          } @else {
            <button type="button" (click)="selectPlan.emit({product, price: product.prices[term]})"
              [ngClass]="{'highlight': product.highlight}" [disabled]="product.plan === currentPlan && lockCurrentPlan">
              {{ actionButtonOverride }}
            </button>
          }
        } @else if (!product.button_link) {
          <button type="button" class="no-link" [tp]="product.more_info">
            {{ product.button_label }}
          </button>
        } @else {
          <button type="button" (click)="selectPlan.emit({product, price: product.prices[term]})"
            [ngClass]="{'highlight': product.highlight}">
            {{ product.button_label }}
          </button>
        }
      </div>
      <div class="features">
        @if (product.marketing_features_header) {
          <div class="feature font-bold">{{ product.marketing_features_header }}</div>
        }
        @for (feature of product.features; track feature) {
          <div class="feature">
            <i class="fa fa-check"></i>
            <div>{{ feature }}</div>
          </div>
        }
    </div>
    </div>
    `,
  styleUrls: ['../_pricing-common.scss', './product.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ProductComponent implements OnInit {
  @Input() product: Product;
  @Input() term: 'annual' | 'monthly' = 'monthly';
  @Input({ required: false }) actionButtonOverride: string | null = null;
  @Input({ required: false }) currentPlan: SubscriptionPlan | null = null;
  @Input({ required: false }) currentPriceId: string | null = null;
  @Input() currentProductId: string;
  @Input() subscriptionStatus: SubscriptionStatus;
  @Output() selectPlan = new EventEmitter<{product: Product, price: Price}>();

  accountTypes = AccountType;
  subscriptionStatuses = SubscriptionStatus;
  price: number = 0;
  lockCurrentPlan = false;

  ngOnInit() {
    if (this.product?.plan === this.currentPlan && this.product?.id === this.currentProductId) {
      this.lockCurrentPlan = true;
    }
  }

  onPurchase() {
    // this.purchasePlan.emit(this.plan);
  }
}
